import { cookieExists, createCookie, lockScroll, unlockScroll } from '../util/common';
import { newModalFromString } from '../components/modal';

class NewsletterPopup {
    init () {
        if (!window.SitePreferences.NewsletterPopupEnabled) {
            return false;
        }

        if (!cookieExists('dw_subscribepopup') && window.SitePreferences.NewsletterPopupEnabled) {
            setTimeout(function () {
                showNewsletterPopup();
            }, window.SitePreferences.NewsletterPopupDelay);
        }

        // Chosen select
        if (Foundation.MediaQuery.atLeast('medium')) {
            $('select.select-chosen').chosen({disable_search: true});
        }
    }

    setCookie () {
        createCookie('dw_subscribepopup', '1', parseInt(window.SitePreferences.NewsletterPopupExpiryDays));
    }

    showPopup () {
        showNewsletterPopup();
    }
}

const canOpenNewsletter = () => {
    let isEnabled = true;
    const disabledEndpoints = window.SitePreferences.NewsletterDisabledEndpoints;
    if (disabledEndpoints.length) {
        const dataAction = $('.page[data-action]');
        if (dataAction.length && dataAction.data('action')) {
            if (disabledEndpoints.indexOf(dataAction.data('action')) > -1) {
                isEnabled = false;
            }
        }
    }

    return isEnabled;
};

function showNewsletterPopup () {
    const url = window.Urls.getNewsletterPopup;
    const onPopupClose = () => {
        unlockScroll();
        createCookie('dw_subscribepopup', '1', parseInt(window.SitePreferences.NewsletterPopupExpiryDays));
    };

    const isEnabled = canOpenNewsletter();

    if (url && isEnabled) {
        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                const modal = newModalFromString(data, false, ['newsletter-popup', 'cc-newsletterPopup'], null, onPopupClose);
                modal.open();

                $('#linkToBeRendered').html($('#formattedLink').text());

                // Chosen select
                if (Foundation.MediaQuery.atLeast('medium')) {
                    $('select.select-chosen').chosen({disable_search: true});
                }

                const whichFormValue = $('#newsletterFooterForm').data('which-form');
                if (whichFormValue === 'newsletter') {
                    $('#email').val($('#newsletter-Email').val());
                } else if (whichFormValue === 'newsletter-contacts') {
                    $('#email').val($('#newsletter-Email-contacts').val());
                } else if (whichFormValue !== 'newsletter-new') {
                    $('#email').val($('#countryNewsletter').val());
                }

                if (!Foundation.MediaQuery.atLeast('large')) {
                    lockScroll();
                }

                $(modal.modalBox)
                    .find('.tingle-modal-box__content')
                    .addClass('cc-height100')
                    .find('.js-newsletterPopup-close')
                    .on('click', function (e) {
                        modal.close();
                    });
                $(modal.modalBox)
                    .find('.newsletter-continue')
                    .on('click', function (e) {
                        modal.close();
                    });

                $('.newsletter-submit').on('click', function (e) {
                    const newsletterForm = $('#newsletter-form-modal');
                    if (newsletterForm.parsley().isValid()) {
                        e.preventDefault();
                        $.spinner().start();
                        $.ajax({
                            url: newsletterForm.attr('action'),
                            type: 'post',
                            dataType: 'json',
                            data: newsletterForm.serialize(),
                            success: function (data) {
                                $.spinner().stop();
                                if (data.alreadySubscribed) {
                                    if ($('.registrationFormStepTwo').hasClass('hidden')) {
                                        $('.registrationFormStepOne').addClass('hidden');
                                        $('.newsletter-step-one').addClass('hidden');
                                        $('.registrationFormStepTwo').removeClass('hidden');
                                        $('.email-popup-info').addClass('hidden');
                                        $('.already-registered-hide').addClass('hidden');
                                        $('.title-already-registered').removeClass('hidden');
                                    }
                                    $('.written-email').text(data.registeredEmail);
                                    $('.selected-country').text(document.querySelector('#newsletterCountry').querySelector('option[value=' + data.countryEmail + ']').innerHTML);
                                } else {
                                    $('#newsletter-step-one').addClass('hidden');
                                    $('#newsletter-step-two').removeClass('hidden');    
                                }
                            },
                            error: function () {
                                $.spinner().stop();
                            }
                        });
                    }
                });

                // Since the form is loaded asynchronously, launch Parsley validation on success
                $('body').trigger('newsletter:showPopup', { form: $(modal.modalBox).find('form') });
                $(modal.modalBox).find('form')
                    .parsley({
                        errorClass: 'is-invalid-input',
                        successClass: 'is-valid-input',
                        errorsWrapper: '<div class="errors-list"></div>',
                        errorTemplate: '<span class="form-error is-visible"></span>'
                    }).on('field:error', e => {
                        if (e.$element.closest('.input-error-group').hasClass('error-outside')) {
                            const elementName = e.$element.attr('name');
                            const error = e.$element.parents('label').next('.errors-list');
                            const $errorLocation = e.$element.closest('form').find(`[data-parsley-error-binding="${elementName}"]`);
                            error.appendTo($errorLocation);
                        }
                    });
            },
            error: function (err) {
                console.log(err);
            }
        });
    }
}

const newsletterPopup = new NewsletterPopup();
export default newsletterPopup;
